// @flow
import React, { Component } from 'react';
import HeaderBlock from '../../components/HeaderBlock';
import { HeaderBlockP } from '../../components/HeaderBlockStyles';
import { SupportDiv } from './SupportStyles';

type Props = {};

export default class Support extends Component<Props> {
  render() {
    return (
      <SupportDiv>
        <HeaderBlock title="Contact Us" withLink>
          <HeaderBlockP>
            If you have any questions feel free to contact us at:
            <a href="mailto:partners@net-cents.com">
              <span>partners@net-cents.com</span>
            </a>
          </HeaderBlockP>
          <HeaderBlockP>
            NetCents support is available 9 am to 5 pm Monday to Friday pacific
            time. We will respond to your email within one business day.
          </HeaderBlockP>
        </HeaderBlock>
      </SupportDiv>
    );
  }
}
